import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { AccountInfoRoutes } from '../../../pages/account-info/constants/routes';
import { useRoleObject } from '../../../pages/arc/components/useRoles';
import { ArcRoutes } from '../../../pages/arc/constants/routes';
import { TcsmStates } from '../../../root/tcsm-model';
import { getLinksByRoles } from '../../helpers/auth-helpers';
import { useBasePath } from '../../hooks/useBasePath';
import { useChurchEmployees } from '../../hooks/useChurchEmployees';
import { YesNoIndicators } from '../../models/api-model';
import { Navigation } from '../../models/navigation-model';
import { ExternalLink } from '../external-link-modal';
import { MobileNavigation } from '../mobile-nav';
import { getMyCpgPodInfo } from '../../ducks/mycpg-pod-api';
import { setPods, setPodsError } from '../../../pages/mycpg-pods/mycpg-pod-slice';
import { MyCpgPodsState } from '../../../pages/mycpg-pods/mycpg-pod-models';

interface MyCpgNavsProps {
	navigation: Navigation;
	admin: boolean;
}

export const NavBar = (props: MyCpgNavsProps) => {
	const { navigation, admin } = props;
	const basePath = useBasePath('');
	const roles = useRoleObject();
	const guid = useSelector<TcsmStates, string>(state => state?.authenticatedState?.clientGuid);
	const isClergy = useSelector<TcsmStates, boolean>(state => state?.personalInfo?.myCPG?.currentPerson?.is_clergy === YesNoIndicators.Yes);

	const isChurchEmployee = useChurchEmployees();
	const dispatch = useDispatch();
	const podInfo = useSelector<TcsmStates, MyCpgPodsState>(state => state?.mycpgPodsState);
	const hasBilling = podInfo?.pods?.ghl_bill_payer === YesNoIndicators.Yes || podInfo?.pods?.pension_bill_payer === YesNoIndicators.Yes;

	useEffect(() => {
		dispatch(getMyCpgPodInfo(
			(data) => {
				dispatch(setPods(data?.data));
			},
			() => {
				dispatch(setPodsError());
			},
		));
	}, [navigation]);


	if (!navigation || !roles || (!admin && !isChurchEmployee) || !podInfo.podsLoaded) return null;

	const allLinks = admin ? getLinksByRoles(navigation.ArcLinks, roles) : navigation.MyCpgLinks.filter(link => link.RolesMatch !== 'billingaccess' || hasBilling);
	const links = isClergy ? allLinks : allLinks.filter(a => !a?.ClergyOnly);
	const homeRoute = admin ? `${basePath}/${ArcRoutes.ArcRoot}` : `${basePath}/${AccountInfoRoutes.MyCpgRoot}`;
	const homeRouteText = admin ? navigation.ArcLinkText : navigation.MyCpgLinkText;
	return (
		<>
			<nav className='nav-desktop'>

				<div className='nav-desktop-main'>
					<ul className='nav-desktop-main-list'>
						<li className='nav-desktop-main-list-item'>
							<Link to={homeRoute}>
								<svg aria-hidden='true' focusable='false'>
									<use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref={admin ? '#arc-icon' : '#mycpg-icon'} />
								</svg>
								{homeRouteText}
							</Link>
						</li>
						{
							links?.map((a, idx) => {
								return (
									<li key={`${idx}-nav`} className='nav-desktop-main-list-item'>
										{
											a?.External ?
												<ExternalLink linkUrl={a?.LinkUrl?.replace('{guid}', guid)} linkText={a.LinkText} newWindow /> :
												<Link to={a.LinkUrl}>{a.LinkText}</Link>
										}
									</li>
								);
							})
						}
					</ul>
				</div>
			</nav>
			<MobileNavigation links={links} homeRoute={homeRoute} homeLinkText={homeRouteText} />
		</>
	);
};
